import { captureHint, type CaptureProfile } from '../lib/voiceCapture.js';

export function CaptureProfileControl({ value, busy, onChange }: {
  value: CaptureProfile; busy: boolean; onChange: (value: CaptureProfile) => void;
}) {
  return <div className="room-listen-control">
    <label>Microphone{' '}
      <select aria-label="Microphone arrangement" value={value} disabled={busy}
        onChange={(event) => onChange(event.target.value === 'personal' ? 'personal' : 'shared')}>
        <option value="shared">People together</option>
        <option value="personal">Just me</option>
      </select>
    </label>
    <span className="room-hint">{captureHint(value)}</span>
  </div>;
}
